import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import GridContainer from './GridContainer';
import HelperText from '../../simple/helper_text';
import {withTranslation} from "react-i18next";

class Exams extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {t} = this.props;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" align={"left"}>
                        {t('list_of_entrance_tests')}
                    </Typography>
                </Grid>
                <Grid item xa={12}>
                    <HelperText message={t('if_exam_not_taken_info')}/>
                </Grid>
                <Grid item xs={12}>
                    <GridContainer/>
                </Grid>
            </Grid>
        );
    }
}

export default withTranslation()(Exams);